import z from "zod";
import { ProjectSchema } from "../projects/ProjectSchema";
import { StandardTestSchema } from "../standardTests/StandardTestSchema";
import { TestEvent, TestEventStatus, WelderTest } from "@/api/williams/testEvents";
import { UserSchema } from "../users";
import { WelderSchema } from "../welders/WelderSchema";

const REQUIRED_FIELD_ERROR = "Required Field";

export const WelderTestSchema = z
  .object({
    testEventWelderTestId: z.string(),
    testEventId: z.string(),
    welderId: z.string(),
    templateId: z.string(),
    submitted: z.boolean(),
  })
  .transform((data) => data as WelderTest);

export const TestEventSchema = z
  .object({
    id: z.string(),
    number: z.string().nonempty(REQUIRED_FIELD_ERROR),
    description: z.string().nonempty(REQUIRED_FIELD_ERROR),
    status: z.nativeEnum(TestEventStatus),
    project: ProjectSchema,
    testEventDate: z.string().nullish(),
    owner: UserSchema,
    weldingSpecialistId: z.string().nonempty(REQUIRED_FIELD_ERROR),
    contractorId: z.string().nullish(),
    supervisor: z.string().nullish(),
    welders: z.array(WelderSchema),
    tests: z.array(StandardTestSchema),
    welderTests: z.array(WelderTestSchema),
  })
  .transform((data) => data as TestEvent)
  .superRefine(async (data, ctx) => {
    if (data.status > TestEventStatus.Partial) {
      runExtendedValidation(data, ctx);
    }
  });

function runExtendedValidation(data: TestEvent, ctx: z.RefinementCtx) {
  if (!data.contractorId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["contractorId"],
      message: REQUIRED_FIELD_ERROR,
    });
  }
  if (!data.supervisor) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["supervisor"],
      message: REQUIRED_FIELD_ERROR,
    });
  }
  if (data.tests.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["tests"],
      message: "Please select at least one test",
    });
  }
}
